<template>
	<div class="product-packaging py-8 md:w-4/5 text-lg">
    <p>
      <span class="font-semibold">Size / Dimension: </span>
      <span>{{ packaging.size }}</span>
    </p>
    <p>
      <span class="font-semibold">Gross Weight: </span>
      <span>{{ packaging.weight }}</span>
    </p>
     <p>
      <span class="font-semibold">Package Type: </span>
      <span>{{ packaging.type }}</span>
    </p>
    <p>
      <span class="font-semibold">Units Per Package: </span>
      <span>{{ packaging.unitsPerPackage }}</span>
    </p>
    <p>
      <span class="font-semibold">Packages Per Container: </span>
      <span>{{ packaging.packagesPerContainer }}</span>
    </p>
  </div>
</template>
<script>
export default {
	name: 'ProductPackaging',
	props: {
		packaging: {
			required: true
		}
	}
}
</script>
<style lang="scss" scoped>
  .product-packaging {
    p {
      @apply pb-2;
    }
  }
</style>
